import PropTypes from 'prop-types';
import React from 'react';
import createReactClass from 'create-react-class';
import Reflux from 'reflux';

import StoreProvider from 'injection/StoreProvider';

import ActionsProvider from 'injection/ActionsProvider';

import { Spinner } from 'components/common';

const MetricsStore = StoreProvider.getStore('Metrics');
const MetricsActions = ActionsProvider.getActions('Metrics');

const StreamThroughput = createReactClass({
  displayName: 'StreamThroughput',

  propTypes: {
    streamId: PropTypes.string.isRequired,
  },

  mixins: [Reflux.connect(MetricsStore)],

  componentWillMount() {
    MetricsActions.addGlobal(this._metricName());
  },

  componentWillUnmount() {
    MetricsActions.removeGlobal(this._metricName());
  },

  _metricName() {
    return `org.graylog2.plugin.streams.Stream.${this.props.streamId}.incomingMessages.1-sec-rate`;
  },

  _calculateThroughput() {
    return Object.keys(this.state.metrics)
      .map((nodeId) => {
        const metricDefinition = this.state.metrics[nodeId][this._metricName()];
        return metricDefinition !== undefined ? metricDefinition.metric.value : 0;
      })
      .reduce((throughput1, throughput2) => throughput1 + throughput2, 0);
  },

  render() {
    if (!this.state.metrics) {
      return <Spinner />;
    }
    return (
      <span>{this._calculateThroughput()} messages/second</span>
    );
  },
});

export default StreamThroughput;
